import React from 'react'
import Navbar from './components/Navbar'
import Hero from './components/Hero'
import Products from './components/Products'
import Services from './components/Services'
import Technology from './components/Technology'
import Applications from './components/Applications'
import Specifications from './components/Specifications'
import About from './components/About'
import Contact from './components/Contact'
import Footer from './components/Footer'

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Products />
      <Services />
      <Technology />
      <Applications />
      <Specifications />
      <About />
      <Contact />
      <Footer />
    </div>
  )
}

export default App 